var _rect, _rect2, _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification_bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1227",
    "data-name": "Rectangle 1227",
    width: 30,
    height: 30,
    transform: "translate(1 1)",
    fill: "#fff",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(24.23 13.06)",
    fill: "#dfdfdf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M20.37,24.73v1.09a4.37,4.37,0,0,1-8.74,0V24.73",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M24.63,11.66a7.97,7.97,0,0,0-2.05-4.68",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M22.58,6.98a8.179,8.179,0,0,0-2.89-1.89,1.208,1.208,0,0,1-.68-.72A3.314,3.314,0,0,0,16,1.81a3.293,3.293,0,0,0-3,2.56,1.235,1.235,0,0,1-.68.72c-2.28.94-5.04,2.86-5.04,8.28,0,5.91-1.24,7-2.99,9.15a1.373,1.373,0,0,0,1.18,2.22H26.54a1.376,1.376,0,0,0,1.17-2.22c-1.52-1.85-2.65-2.92-2.92-7",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDisableIcon);
export default __webpack_public_path__ + "static/media/notification-disable-icon.33c0348f2e75b19a6a59998504db4d15.svg";
export { ForwardRef as ReactComponent };